import React from "react";
import { Helmet } from "react-helmet";
import MultiLingualContent from "../../../languages/MultiLingualContent";
import BackButton from "../../backButton";
import pachit1 from "../../../assets/images/pachit1.jpeg";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Pachit = () => {
  return (
    <div className="inner-section" id="pachit">
      <Helmet>
        <title>פטרידע - הפטריה פכית</title>
        <meta
          name="description"
          content="הפטריה פכית - Scutellinia: תאור, זיהוי ותמונות"
        />
      </Helmet>
      <BackButton path="/#types-and-species" />
      <h2>
        <MultiLingualContent contentID="pachit" />
      </h2>
      <>
        <div className="informationText">
          <p>
            <MultiLingualContent contentID="pachitText1" />
          </p>
          <p>
            <MultiLingualContent contentID="pachitText2" />
          </p>
          <p>
            <MultiLingualContent contentID="pachitText3" />
          </p>
          <br />
          <p>
            <b>
              <MultiLingualContent contentID="pachitText4Bold" />
            </b>
          </p>
          <p>
            <MultiLingualContent contentID="pachitText5" />
          </p>
          <div className="informationImages">
            <div className="imgWrapper">
              <LazyLoadImage src={pachit1} alt="פכית" />
              <p>
                <MultiLingualContent contentID="pachitImg1" />
              </p>
            </div>
          </div>
          <p>
            <MultiLingualContent contentID="pachitText6" />
          </p>
          <ul>
            <li>
              <MultiLingualContent contentID="pachitText7" />
            </li>
            <li>
              <MultiLingualContent contentID="pachitText8" />
            </li>
            <li>
              <MultiLingualContent contentID="pachitText9" />
            </li>
          </ul>
        </div>
      </>
    </div>
  );
};

export default Pachit;
